<template>
  <div
    role="status"
    data-skeleton
    aria-hidden="true"
    class="bg-carbon-200/30 inline-block overflow-hidden relative"
  />
</template>

<style scoped>
[data-skeleton]::after {
  @apply absolute inset-0 -translate-x-full content-[''];

  animation: shimmer 2s infinite;
  background-image: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0,
    rgba(255, 255, 255, 0.2) 20%,
    rgba(255, 255, 255, 0.5) 60%,
    rgba(255, 255, 255, 0)
  );

  @keyframes shimmer {
    100% {
      @apply translate-x-full;
    }
  }
}
</style>
